<template>
  <!-- 关于 -->
  <div class="guan">
    <!-- 第一行 -->
    <el-row><el-col :span="20" :offset="2">
        <div class="one">
          <h1>关于项目</h1>
        </div>
        <div class="two">
          <p class="b">星系马戏团项目(GALAXYCIRCUS)是由国家天文科学数据中心推出的一项全新的全民科学项目。其核心目标是结合天文数据，揭示宇宙的谜团。项目以 <span class="a">DESI
              Legacy Surveys</span> 项目中的亮星系巡天数据 <span class="a">BGS(DESI Bright Galaxy Survey)</span>
            为基础，由国家天文台的李楠研究员团队、太原理工大学的贾鹏教授团队，以及国家天文科学数据中心中国虚拟天文台团队协作开发。星系马戏团项目将引入人工智能技术，通过与公众互动，参与者无需深入学习专业知识便可直接操作来筛选星系图像中的异常天体。这不仅有助于参与者直观地了解星系的形态，还能够帮助科学家快速发现宇宙中的异常现象
          </p>
          <p class="d">图像数据来源:<a style="font-size:16px;color:rgb(64, 158, 255)"
              href="https://www.legacysurvey.org/viewer">https://www.legacysurvey.org/viewer</a></p>
          <p class="c">图表数据来源: <a style="font-size:16px;color:rgb(64, 158, 255)"
              href="https://ui.adsabs.harvard.edu/abs/2023AJ....165..253H/abstract">https://ui.adsabs.harvard.edu/abs/2023AJ....165..253H/abstract</a>
          </p>
          <p class="c">国际同类项目: <a style="font-size:16px;color:rgb(64, 158, 255)"
              href="https://www.zooniverse.org/projects/zookeeper/galaxy-zoo/">https://www.zooniverse.org/projects/zookeeper/galaxy-zoo/</a>
          </p>
        </div>
      </el-col></el-row>
    <!-- 第二行 -->
    <el-row><el-col :span="20" :offset="2">
        <div class="three">
          <h1>开发及内测团队</h1>
          <p>(汉语拼音排序)</p>
        </div>
        <div class="four">
          <el-row>
            <el-col :span="24">
              <b>开发团队:</b>
              <p class="p">贾鹏(PI), 吕佳蒙, 李楠, 李珊珊, 李鉴, 李作振, Mah·Rukh, Sabiha·Omer, 宋宇, 周朴 </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <b>内测团队：</b>
              <p class="p">贾鹏(PI), 吕佳蒙, 李楠, 李珊珊, 李作振, Mah·Rukh, Sabiha·Omer, 宋宇, 邹虎, 周朴, 张震</p>
            </el-col>
          </el-row>
        </div>
      </el-col></el-row>
    <!-- 第三行 -->
    <div class="big-three">
      <el-row>
        <el-col :span="9" :offset="2">
          <div class="h">
            <el-row>
              <el-col :span="5" :offset="2"><img src="../assets/logo2.png" alt=""></el-col>
              <el-col :span="15" :offset="1">
                <p style="font-size:16px">National Astronomical Data Center<br></p><span>国家天文科学数据中心</span>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="15" :offset="6"><span
                  style="font-size:16px;line-height:80px">提供计算、存储资源和技术支持</span></el-col>
            </el-row>
          </div>
        </el-col>

        <el-col :span="8" :offset="2">

          <a href="https://www.sstm-sam.org.cn/#/home">
            <div class="h1">
              <el-row>
                <el-col :span="10" :offset="7"><span style="font-size:18px;">项目特别合作伙伴</span></el-col>
              </el-row>

              <el-row>
                <el-col :span="5" :offset="7"><img src="../assets/4.png" alt=""></el-col>
              </el-row>
            </div>
          </a>

        </el-col>
      </el-row>
    </div>

    <!-- 第四行 -->
    <div class="big-four">
      <el-row>
        <el-col :span="9" :offset="2">
          <div class="h2">
            <el-row>
              <el-col :span="13" :offset="5"><span>如果您在使用中遇到任何问题欢迎随时与我们交流</span></el-col>
            </el-row>

            <el-row>
              <el-col :span="10" :offset="7">
                <div class="but"><b><a style="text-decoration: none;color:black " target="_blank"
                      href="https://gitee.com/zhou--pu/galaxycircus-public/issues">提交反馈</a></b></div>
              </el-col>
            </el-row>
          </div>
        </el-col>

        <el-col :span="8" :offset="2">
          <div class="h3">
            <el-row>
              <el-col :span="19" :offset="2">

                <div><span style="margin-left:40px;">访问微信公众号<b>虚拟天文台</b>了解更多</span></div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="17" :offset="8">

                <div> <img src="../assets/06.jpg" alt=""></div>

              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.big-three {
  width: 100%;
  height: 300px;
}

.big-four {
  width: 100%;
  height: 300px;
}

.guan {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.a {
  color: rgb(64, 158, 255);
  font-size: 16px;
}

.c {
  margin-left: 74px;
  margin-bottom: 22px;
  font-size: 16px;
}

.d {
  margin-left: 74px;
  margin-top: -20px;
  margin-bottom: 22px;
  font-size: 16px;
}

.one {
  font-size: 18px;
  height: 60px;
  background-color: rgb(51, 51, 51);
  color: rgb(235, 241, 240);
  text-align: center;
  line-height: 60px;
  border-top-left-radius: 10px; //左上角
  border-top-right-radius: 10px; //右上角
}

.two {
  height: 100%;
  background-color: rgb(63, 63, 63);
  color: rgb(235, 241, 240);
  margin-bottom: 50px;
  padding-bottom: 20px;
  border-bottom-left-radius: 10px; //左下角
  border-bottom-right-radius: 10px; //右下角
  font-size: 16px;

  .b {
    text-indent: 2em;
    padding: 30px;
    line-height: 30px;
  }
}

.three {
  height: 110px;
  background-color: rgb(51, 51, 51);
  color: rgb(235, 241, 240);
  text-align: center;
  line-height: 70px;
  border-top-left-radius: 10px; //左上角
  border-top-right-radius: 10px; //右上角

  p {
    position: relative;
    bottom: 30px;
  }
}

.four {
  line-height: 40px;
  padding: 40px 42px;
  height: 100%;
  background-color: rgb(63, 63, 63);
  color: rgb(235, 241, 240);
  margin-bottom: 60px;
  border-bottom-left-radius: 10px; //左下角
  border-bottom-right-radius: 10px; //右下角

  .p {
    word-spacing: 20px;
  }
}

.h {
  padding-top: 40px;
  // text-align: center;
  color: white;
  width: 450px;
  height: 220px;
  background-color: rgb(48, 9, 10);
  border-radius: 10px;

  img {
    width: 100px;
    height: 60px;
    margin-top: -5px;
  }
}

.h1 {
  color: white;
  width: 390px;
  height: 50%;
  background-color: rgb(12, 21, 40);
  line-height: 90px;
  border-radius: 10px;
  margin-left: 50px;

  img {
    width: 150px;
    height: 90px;
  }
}

.h2 {
  font-size: 16px;
  padding-top: 40px;
  line-height: 30px;
  text-align: center;
  color: white;
  margin-top: 5px;
  width: 450px;
  height: 220px;
  background-color: rgb(32, 32, 32);
  margin-bottom: 70px;
  border-radius: 10px;

  .but {
    border-radius: 20px;
    margin-top: 20px;
    text-align: center;
    line-height: 55px;
    width: 180px;
    height: 55px;
    background-color: rgb(170, 170, 170);
  }

  .but:hover {
    background-color: rgb(100, 36, 37);
  }
}

.h3 {
  font-size: 16px;
  line-height: 100px;
  margin-top: 5px;
  margin-left: 50px;
  width: 390px;
  height: 220px;
  background-color: rgb(32, 32, 32);
  color: white;
  border-radius: 10px;

  img {
    width: 36%;
    height: 100px;
    border-radius: 5px;
    position: relative;
    bottom: 10px;
    right: -15px;
  }
}
</style>